export interface tableSettingsProps {
    dense: boolean;
    disableBadge: boolean;
    disablePagination: boolean;
    disableSearch: boolean;
}

export interface configReducerProps {
    viewMember: number;
    readMore: boolean;
    membersResponse: boolean | null;
    tableSettings: tableSettingsProps;
}

export const configReducerInitialState: configReducerProps = {
    viewMember: 0,
    readMore: false,
    membersResponse: null,
    tableSettings: {
        dense: false,
        disableBadge: false,
        disablePagination: true,
        disableSearch: false
    }
};

export type ConfigActions =
    | {
          type: 'RESET';
      }
    | {
          type: 'SET_VIEW-MEMBER';
          viewMember: number;
      }
    | {
          type: 'SET_READ-MORE';
          readMore: boolean;
      }
    | { type: 'TOGGLE_TABLE_SETTINGS_DENSITY' }
    | { type: 'TOGGLE_TABLE_SETTINGS_BADGE' }
    | { type: 'TOGGLE_TABLE_SETTINGS_PAGINATION' }
    | { type: 'TOGGLE_TABLE_SETTINGS_SEARCH' };

export const configReducerInit = (initialState: configReducerProps) => {
    return {
        viewMember: initialState.viewMember,
        readMore: initialState.readMore,
        membersResponse: initialState.membersResponse,
        tableSettings: {
            dense:
                localStorage.getItem('Table_Settings_Density') === 'true'
                    ? !initialState.tableSettings.dense
                    : initialState.tableSettings.dense,
            disableBadge:
                localStorage.getItem('Table_Settings_Badge') === 'true'
                    ? !initialState.tableSettings.disableBadge
                    : initialState.tableSettings.disableBadge,
            disablePagination:
                localStorage.getItem('Table_Settings_Pagination') === 'true'
                    ? !initialState.tableSettings.disablePagination
                    : initialState.tableSettings.disablePagination,
            disableSearch:
                localStorage.getItem('Table_Settings_Search') === 'true'
                    ? !initialState.tableSettings.disableSearch
                    : initialState.tableSettings.disableSearch
        }
    };
};

export const configReducer = (state: configReducerProps, action: ConfigActions) => {
    switch (action.type) {
        case 'RESET':
            return configReducerInit(configReducerInitialState);
        case 'SET_VIEW-MEMBER':
            return {
                ...state,
                viewMember: action.viewMember
            };
        case 'SET_READ-MORE':
            return {
                ...state,
                readMore: action.readMore
            };
        case 'TOGGLE_TABLE_SETTINGS_DENSITY':
            localStorage.setItem(
                'Table_Settings_Density',
                JSON.stringify(!state.tableSettings.dense)
            );
            return {
                ...state,
                tableSettings: {
                    ...state.tableSettings,
                    dense: !state.tableSettings.dense
                }
            };
        case 'TOGGLE_TABLE_SETTINGS_BADGE':
            localStorage.setItem(
                'Table_Settings_Badge',
                JSON.stringify(!state.tableSettings.disableBadge)
            );
            return {
                ...state,
                tableSettings: {
                    ...state.tableSettings,
                    disableBadge: !state.tableSettings.disableBadge
                }
            };
        case 'TOGGLE_TABLE_SETTINGS_PAGINATION':
            localStorage.setItem(
                'Table_Settings_Pagination',
                JSON.stringify(!state.tableSettings.disablePagination)
            );
            return {
                ...state,
                tableSettings: {
                    ...state.tableSettings,
                    disablePagination: !state.tableSettings.disablePagination
                }
            };
        case 'TOGGLE_TABLE_SETTINGS_SEARCH':
            localStorage.setItem(
                'Table_Settings_Search',
                JSON.stringify(!state.tableSettings.disableSearch)
            );
            return {
                ...state,
                tableSettings: {
                    ...state.tableSettings,
                    disableSearch: !state.tableSettings.disableSearch
                }
            };
        default:
            return state;
    }
};
